export default [
    {
        path: "/agent/dashboard",
        name: "agent-dashboard",
        component: () => import("@/views/agent/dashboard.vue"),
    },
    {
        path: "/agent/generate",
        name: "agent-generate",
        component: () => import("@/views/agent/generate.vue"),
    },
    {
        path: "/agent/history",
        name: "agent-history",
        component: () => import("@/views/agent/history.vue"),
    },
]